module.exports = __webpack_public_path__ + "static/media/Krombacher-SansDemiItalic.11bf3909.woff2";